import type { Entry, EntrySkeletonType } from 'contentful';

export type ContentfulEntry = Entry<EntrySkeletonType, 'WITHOUT_UNRESOLVABLE_LINKS'>;

export const validateResponse = (entry: ContentfulEntry, entries: string[]) => {
  entries.forEach((fieldName) => {
    const field = entry.fields[fieldName];

    if (!field || (Array.isArray(field) && field.length < 1)) {
      throw new Error(`Expected ${fieldName} in ${entry.fields.internalName}: ${entry.sys.id}`);
    }
  });
};
